<template>
  <b-container fluid class="oscillography-analysis__alarms">
    <b-row class="oscillography-analysis__alarms-toolbar align-items-center">
      <b-col cols="auto">
        <b-form-group class="oscillography-analysis__toggle mb-0">
          <b-form-radio-group
            buttons
            button-variant="outline-primary"
            size="sm"
            :checked="alarmMode"
            :value="alarmMode"
            :options="alarmModeOptions"
            @input="$emit('update:alarmMode', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <b-form-radio-group
          v-model="persistenceMode"
          class="oscillography-analysis__persistence-radio-group"
          :options="persistenceModeOptions"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <section class="oscillography-analysis__alarm-chart">
          <s-empty-list
            v-if="loading || !alarmRows.length"
            :loading="loading"
          />
          <oscillography-alarm-chart
            v-else
            :rows="alarmRows"
            :alarm-mode="alarmMode"
            :persistence-mode="persistenceMode"
            :phase="phase"
          />
        </section>
      </b-col>
    </b-row>

    <b-row class="oscillography-analysis__alarm-actions justify-content-end">
      <b-col cols="auto">
        <b-button
          variant="outline-success"
          size="sm"
          @click="openHistory"
        >
          {{ $t('engineering.oscillography-analysis.alarms.persistence.history') }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OscillographyAlarmChart from '@/components/charts/oscillography/OscillographyAlarmChart';

export default {
  name: 'OscillographyAnalysisAlarmPersistence',
  components: {
    OscillographyAlarmChart,
  },
  props: {
    alarmMode: {
      type: String,
      default: 'breaker',
    },
    alarmModeOptions: {
      type: Array,
      default: () => [],
    },
    phase: {
      type: String,
      default: '',
    },
    rows: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    persistenceMode: 'percentage',
  }),
  computed: {
    alarmRows() {
      return this.rows;
    },
    persistenceModeOptions() {
      return [
        {
          text: this.$t('engineering.oscillography-analysis.alarms.persistence.percentage'),
          value: 'percentage',
        },
        {
          text: this.$t('engineering.oscillography-analysis.alarms.persistence.quantity'),
          value: 'quantity',
        },
      ];
    },
  },
  methods: {
    openHistory() {
      this.$emit('open-history');
    },
  },
};
</script>

<style lang="sass" scoped>
.oscillography-analysis
  &__alarms
    padding-top: .5rem

  &__alarms-toolbar
    margin-bottom: 1rem

  &__persistence-radio-group
    display: flex
    gap: 1.5rem
    align-items: center

  &__alarm-chart
    padding: 0 1rem 1rem
    border: 1px solid var(--color-border-gray, #8d8d8d)
    border-radius: .25rem
    background: var(--color-background-regular, #1a1a1a)

  &__alarm-actions
    margin-top: 1rem
</style>
